<template>
  <div style="width:800px">
    <el-row :gutter="20">
      <el-input v-model="topic" style="width:150px;" placeholder="型号"></el-input>
      <el-input v-model="title" style="width:150px;" placeholder="商品名称"></el-input>
      <el-input v-model="publisher" style="width:150px;" placeholder="厂商名称"></el-input>
      <!-- <el-select v-model="goodsType" placeholder="商品类型" style="width:150px;">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>-->
      <el-button @click="handleQuery">查询</el-button>
      <el-button @click="handleReset">重置</el-button>
    </el-row>
    <el-row>
      <el-col :span="8">
        <el-button @click="handleAdd">新增</el-button>
      </el-col>
      <el-table :data="gridData" border highlight-current-row max-height="500">
        <el-table-column prop="imageUrl" label="外观图片">
          <template slot-scope="scope">
            <el-image style="width: 50px; height: 50px" :src="scope.row.imageUrl"></el-image>
          </template>
        </el-table-column>
        <el-table-column property="title" label="商品名称" width="200"></el-table-column>
        <el-table-column property="topic" label="商品型号" width="150"></el-table-column>
        <el-table-column property="publisher" label="厂家名称"></el-table-column>
        <el-table-column property="price" label="定价" width="150"></el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small">编辑</el-button>
            <!-- <el-button type="text" @click="handleRemove(scope.row)" size="small">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-dialog
      v-bind="dialogOption"
      :view.sync="dialogOption.view"
      :visible.sync="dialogOption.show"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <component
        :is="dialogOption.view"
        :dialogData="dialogData"
        :IsEdit="isEdit"
        @close="closeDialog"
      ></component>
    </el-dialog>
  </div>
</template>
<script>
import Sortable from "sortablejs";
import addGoods from "../components/addGoods";
import {
  queryActionList,
  deleteActionRow,
  savePublisher,
  updatPublisher,
  sysUpdate,
  queryGoods,
  bookList
} from "@/api/sysinfo";
import { Message } from "element-ui";
export default {
  components: { addGoods },
  data() {
    return {
      gridData: [],
      dialogOption: {
        title: "新增商品",
        width: "1200px",
        view: "",
        show: false
      },
      updateRow: {},
      position: 3,
      options: [
        {
          value: 1,
          label: "纸质书"
        },
        {
          value: 2,
          label: "电子书"
        },
        {
          value: 3,
          label: "非书籍"
        }
      ],
      goodsType: "",
      topic: "",
      title: "",
      publisher: "",
      dialogData: {},
      isEdit: false
    };
  },
  mounted() {
    // 需要请求后台数据，对页面进行初始化
    this.getData();
  },
  methods: {
    // 编辑
    handleClick(row) {
      this.dialogData = row;
      this.isEdit = true;
      this.showDialog("新增商品", "addGoods");
    },
    // 删除
    handleRemove(row) {
    //   console.log(row);
      this.$confirm("是否确认删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let params = {
            linkId: row.linkId
          };
          deleteActionRow(params).then(data => {
            Message({
              message: "删除成功",
              type: "success",
              duration: 5 * 1000
            });
            this.getData();
          });
        })
        .catch(() => {});
    },
    // 打开对话框
    showDialog(title, view, width = "1200px") {
      this.dialogOption.view = view;
      this.dialogOption.title = title;
      this.dialogOption.show = true;
    },
    closeDialog() {
      // 如果有值传进来，则做更新操作
      this.dialogOption.show = false;
      this.dialogOption.view = "";
      this.dialogOption.title = "";
      this.getData();
    },
    // 获取数据
    getData() {
      let params = {
        goodsType: 3
      };
      queryGoods(params).then(data => {
        this.gridData = data.data.list;
      });
    },
    // 新增商品
    handleAdd() {
      this.showDialog("新增商品", "addGoods");
    },
    // 查询
    handleQuery() {
      let params = {
        topic: this.topic,
        title: this.title,
        publisher: this.publisher,
        goodsType: 3
      };
      queryGoods(params).then(data => {
        this.gridData = data.data.list;
      });
    },
    // 重置
    handleReset() {
      this.title = "";
      this.topic = "";
      this.publisher = "";
      this.goodsType = "";
    }
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/SysManager/ClassifyInfo/OtherCategory/index.vue